/**
 * Registers the service worker and shows a banner when a new version is
 * ready to activate — the counterpart of `registerType: 'autoUpdate'` in
 * `vite.config.ts` for the case where reloading immediately would interrupt
 * a volunteer mid-visit.
 */
import { useRegisterSW } from 'virtual:pwa-register/react';

import { Button, Card } from '../components/ui';
import { t } from '../i18n/fr';

/**
 * Render the "new version available" banner, or nothing.
 *
 * @returns The banner element, or `null` when no update is pending.
 */
export function UpdatePrompt() {
  const { needRefresh, updateServiceWorker } = useRegisterSW();
  const [isVisible, setIsVisible] = needRefresh;

  if (!isVisible) {
    return null;
  }

  return (
    <div className="pwa-banner" role="status">
      <Card>
        <p className="ui-label">{t('pwa.update.title')}</p>
        <p>{t('pwa.update.body')}</p>
        <div className="pwa-banner__actions">
          <Button type="button" onClick={() => void updateServiceWorker(true)}>
            {t('pwa.update.action')}
          </Button>
          <Button type="button" variant="ghost" onClick={() => setIsVisible(false)}>
            {t('pwa.update.dismiss')}
          </Button>
        </div>
      </Card>
    </div>
  );
}
